import { render } from "./PricingPlan.vue?vue&type=template&id=eab6ad38&scoped=true"
import script from "./PricingPlan.vue?vue&type=script&lang=js"
export * from "./PricingPlan.vue?vue&type=script&lang=js"

import "./PricingPlan.vue?vue&type=style&index=0&id=eab6ad38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eab6ad38"]])

export default __exports__